import { AcceptanceStatus, DataKYCFileTctWithFile } from '@dealstack/shared/lib/generated';
import {
	KYCDocumentStatus,
	REQUESTED_STATUS,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/components/utils';

export const getFormCardDocumentStatus = (
	kycFile: DataKYCFileTctWithFile | undefined
): KYCDocumentStatus => {
	if (!kycFile) {
		return REQUESTED_STATUS;
	}
	return kycFile.status ?? AcceptanceStatus.PENDING;
};
